import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { Button } from 'antd';
import { ArrowsAltOutlined } from '@ant-design/icons';
import RankingGrid from './RankingGrid';

const RankingFullModalGrid = ({ gridData }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [gridHeight, setGridHeight] = useState('200px');

  const handleOpen = () => {
    setGridHeight('85vh');
    onOpen();
  };

  return (
    <>
      <Button
        icon={<ArrowsAltOutlined />}
        iconPosition="start"
        size="small"
        onClick={handleOpen}
      >
        Show grid in full size
      </Button>

      <Modal onClose={onClose} size="full" isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Pool Ranking Candidates Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <RankingGrid height={gridHeight} gridData={gridData} />
          </ModalBody>
          <ModalFooter>
            {/* Optional: You can add footer content here if needed */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default RankingFullModalGrid;
